// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgj_a bhp_vt bhp_ea bhp_a","MenuItem__Btn":"bgj_b bhp_z","MenuItem__subtitle":"bgj_c"};